import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import ValueCards from "./components/ValueCards";
import SpreadsheetPreview from "./components/SpreadsheetPreview";
import CategoriesSection from "./components/CategoriesSection";
import ContentSection from "./components/ContentSection";
import ArticleEntry from "./components/ArticleEntry";
import PillarArticles from "./components/PillarArticles";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <ValueCards />
        <SpreadsheetPreview />
        <CategoriesSection />
        <ContentSection />
        <ArticleEntry />
        <PillarArticles />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}